module.exports = __webpack_public_path__ + "static/resources-list-trigger-backup-d8a78e2bfe7e51f8b003ab0ad2d67dba.png";